import axios from 'axios';
import { API_URL } from '../config';

export const SERVER_ERROR_ROUTES = ['/server-down', '/timeout', '/connection-error', '/it-error'];

export const isServerErrorRoute = (path = window.location.pathname) =>
  SERVER_ERROR_ROUTES.includes(path);

export const isBackendOutageError = (error) => {
  if (!error) return false;

  // Canceled requests are not backend outages
  if (
    axios.isCancel(error) ||
    error.code === 'ERR_CANCELED' ||
    error.name === 'CanceledError' ||
    error.message === 'canceled'
  ) {
    return false;
  }

  // If request config specifies skipOutageRedirect, don't treat as global outage
  if (error.config?.skipOutageRedirect) {
    return false;
  }

  const status = error.response?.status;
  const isAxiosError = error.isAxiosError || Boolean(error.request) || Boolean(error.response);

  if (!isAxiosError) return false;

  return (
    !error.response ||
    status === 502 ||
    status === 503 ||
    status === 504
  );
};

export const checkServerHealth = async ({ timeout = 5000 } = {}) => {
  const token = localStorage.getItem('token');

  try {
    await axios.get(`${API_URL}/employees/it`, {
      timeout,
      headers: token ? { Authorization: `Bearer ${token}` } : undefined
    });
    return true;
  } catch (error) {
    if (isBackendOutageError(error)) {
      return false;
    }

    // A non-outage HTTP response still proves the backend is reachable.
    return Boolean(error.response);
  }
};

export const createServerStatusSource = () =>
  new EventSource(`${API_URL}/server-status/stream`);
